module.exports = __webpack_public_path__ + "img/account-choose-icon.9c61d2b8.svg";